import { tasksId } from "../../../types/activityTasks";
import { completeOneTask } from "../../../store/slices/menu/tunks";
import { BarStatusActivies } from "../../../components/common/BarStatusActivies";
import React, { useEffect, useState } from "react";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useGetActivitiesBySubTopic } from "../../../hooks/useGetActivitiesBySubTopic";
import { DialogBarNew } from "../../../components/common/DialogBarNew";
import { HeaderRedPresentation } from "../../../components/common/HeaderRedPresentation";
import { PanelActivities } from "../../../components/common/PanelActivities";
import { ValidationResultModal } from "../../../components/common/ValidationResultModal";
import { ButtonPlay } from "../../../components/common/ButtonPlay";
import { ButtonHome } from "../../../components/common/ButtonHome";
import { audiosAssets } from "../../../assets/audio";
import { voicesTypeControl } from "../../../types/audioType";
import { ButtonReturn } from "../../../components/common/ButtonReturn";

const steps = {
	dialogOne: 1,
	viewActivities: 2,
	dialogTwo: 3,
	dialogThree: 4,
	dialogFourMonitor: 5,
	winActivity: 6,
}

export const Tema4SubtopicThreeActivityTwo = () => {
	const dispatch = useDispatch();
	const navigation = useNavigate();
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const [uiToShow, setUiToShow] = useState(1);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema4.activities.subtema3], 2);
	useEffect(() => {
		if (loaded) {
			console.log("tema 4 subtema3 activity 2");
			ObserverEmitter.emit(EVENTS.tema4.subtopicThree.initScene, 2);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.selectCharacterScene)
		}
	}, [loaded]);
	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub03.sub3_act2_a01)
	})
	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema4.subtopicThree.initScene, 2);
						setUiToShow(1)
					}} />
				)}
			</>
			{uiToShow === steps.dialogOne && (
				<>
					<HeaderRedPresentation name="Actividad 2: Venta sugerida." />
					<DialogBarNew
						dialog={
							"Otra de las actividades es la Venta Sugerida a continuación te explicaré un poco al respecto."
						}
						percentage={"25%"}
						callback={() => {
							setUiToShow(steps.viewActivities);
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.viewActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 3: Formas de pago y venta sugerida"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							setUiToShow(steps.dialogTwo);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub03.sub3_act2_a02)
						}}
						activities={tasksList}
					/>
				</>
			)}
			{uiToShow === steps.dialogTwo && (
				<>
					<BarStatusActivies activities={tasksList} />
					<DialogBarNew
						dialog={
							"La venta sugerida es cuando ofrecemos productos en promoción al solicitar tiempo aire y un servicio."
						}
						percentage={"50%"}
						callback={() => {
							setUiToShow(steps.dialogThree);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub03.sub3_act2_a03)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogThree && (
				<>
					<DialogBarNew
						dialog={
							"Esto también puede aplicar en la compra de ciertos productos."
						}
						percentage={"75%"}
						callback={() => {
							setUiToShow(steps.dialogFourMonitor);
							ObserverEmitter.emit(EVENTS.tema4.subtopicThree.activityTwo.showMonitor);
							ObserverEmitter.emit(EVENTS.tema4.subtopicThree.activityTwo.moveCameraToMonitor);
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T4.sub03.sub3_act2_a04)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.dialogFourMonitor && (
				<>
					<DialogBarNew
						dialog={
							"Lo más importante que debes recordar al hacer una venta sugerida es loguearte con tu usuario para tener el incentivo cada que se cumpla la meta del mes."
						}
						percentage={"100%"}
						callback={() => {
							setUiToShow(steps.winActivity);
							ObserverEmitter.emit(EVENTS.tema4.subtopicThree.activityTwo.hideMonitor);
							ObserverEmitter.emit(EVENTS.tema4.subtopicOne.activityTwo.returnToDesk);
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
						}}
					></DialogBarNew>
				</>
			)}
			{uiToShow === steps.winActivity && (
				<>
					<div className="fixed z-10 bg-[#00000074] h-full w-full"></div>
					<ValidationResultModal
						title="¡Bien hecho!"
						numberPoints={10}
						dialogModal="Ten en cuenta llevar a la práctica lo que has aprendido en tu dia a dia."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 2,
									pointsWin: 10,
									subtema: tasksId.tema4.activities.subtema3,
								})
							);
							navigation("/home4/tema4/subtema3/results");
						}}
					/>
				</>
			)}

		</>

	)
}